import React, { HTMLAttributes } from "react";

import PropTypes from "prop-types";
import cn from "classnames";
import DialogCloseButton from "./DialogCloseButton";

/**
 * @description DialogHeader UI Component Property type 정의
 * @interface IDialogHeaderProps
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
interface IDialogHeaderProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * @description 클래스 이름에 붙는 접두어. 기본 css를 사용하지않고 커스텀 css를
   * 적용할 때 사용
   */
  dialogPrefix?: string;

  /**
   * @description 헤더에 닫기 버튼 삽입 여부
   */
  closeButton?: boolean;

  //onRequestClose?: Function | undefined;
  onRequestClose?:any
}

/**
 * @description DialogHeader UI Component State type 정의
 * @interface IDialogHeaderStates
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
interface IDialogHeaderStates extends HTMLAttributes<HTMLDivElement> {}

/**
 * @description DialogHeader UI Component
 * 다이얼로그 레이아웃 에서 헤더 부분 렌더링 UI
 * @class DialogHeader
 * @extends {React.Component<IDialogHeaderProps, IDialogHeaderStates>}
 */
class DialogHeader extends React.Component<
  IDialogHeaderProps,
  IDialogHeaderStates
> {
  static propTypes: PropTypes.InferProps<IDialogHeaderProps>;
  static defaultProps = {
    closeButton: false
  };


  /**
   * @description 기본 Dialog Prefix.
   * (default prefix 사용 시 default style가 적용되며, 임의의 prefix 입력시 Custom stylesheet 적용 가능
   * @private
   * @memberof DialogHeader
   */
  private defaultDialogPrefix = "modal";

  /**
   * @description 다이얼로그 헤더 부분 렌더링
   * @method render
   * @returns 렌더링 된 React type element
   * @memberof DialogHeader
   */
  render() {
    const {
      dialogPrefix,
      closeButton,
      children,
      "aria-label": label,
      className,
      onRequestClose,
      ...props
    } = this.props;
    const prefix = dialogPrefix || this.defaultDialogPrefix;
    const headerClassName = cn(className, prefix + "-header");

    return (
      <div {...props} className={headerClassName}>
        {closeButton && (
          <DialogCloseButton
            className="close"
            aria-label={label}
            onClick={onRequestClose}
            
          >
            <span aria-hidden="true">&times;</span>
          </DialogCloseButton>
        )}
        {children}
      </div>
    );
  }
}

export default DialogHeader;
